export function updateHamburger(button: HTMLElement, progress: number): void {
    button.style.setProperty('--hamburger-progress', String(progress));
}

// data-target で指定した .drawer-side 要素に対応するハンバーガーを検索
export function findHamburgers(drawerSide: HTMLElement): HTMLElement[] {
    return Array.from(document.querySelectorAll<HTMLElement>('.hamburger[data-target]')).filter(btn => {
        const selector = btn.dataset.target;
        if (!selector) return false;
        try { return drawerSide.matches(selector); } catch { return false; }
    });
}

// toggle.change をトリガーに drawerSide の実座標をポーリングして --hamburger-progress を更新する
// DaisyUI が translate / transform / grid など何で実装していても getBoundingClientRect() で取得可能
export function bindHamburger(btn: HTMLElement, drawerSide: HTMLElement): void {
    if (btn.dataset.hamburgerBound) return;
    btn.dataset.hamburgerBound = 'true';

    // バー間ギャップを CSS 変数に同期（--_move の計算に使用）
    btn.style.setProperty('--hamburger-gap', getComputedStyle(btn).gap || '0px');

    const isEnd = !!drawerSide.closest('.drawer')?.classList.contains('drawer-end');
    // DaisyUI v4: .drawer-side 自体は fixed/full-width で動かない
    // 実際にスライドするのは :not(.drawer-overlay) の子パネル
    const panel = drawerSide.querySelector<HTMLElement>(':scope > :not(.drawer-overlay)');

    function tick(): void {
        // ドラッグ中は drawer/index.ts が直接 updateHamburger を呼ぶので skip
        if (!btn.dataset.hamburgerDragging && panel) {
            const rect = panel.getBoundingClientRect();
            const panelWidth = panel.offsetWidth;

            if (panelWidth > 0) {
                // left drawer: open → rect.left≈0, closed → rect.left≈-panelWidth
                // right drawer: open → rect.right≈innerWidth, closed → rect.right≈innerWidth+panelWidth
                const progress = isEnd
                    ? Math.min(1, Math.max(0, 1 - (rect.right - window.innerWidth) / panelWidth))
                    : Math.min(1, Math.max(0, (rect.left + panelWidth) / panelWidth));
                updateHamburger(btn, progress);
            }
        }
        requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
}
